import { FaqPageContent } from '@/components/faq/FaqPageContent';
import { FaqPageMenu } from '@/components/faq/FaqPageMenu';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import type { Config } from '@/pageConfig/faq';
import { Flex } from '@lemonade-hq/cdk';
import type { Locale } from '@lemonade-hq/lemonation';
import { Faq } from 'contentlayer/generated';
import type React from 'react';
import style from 'styled-components';

const ContentWrapper = style(Flex)`
  position: relative;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
`;

interface FaqPageTemplateProps {
  config: Config;
  locale: Locale;
}

export const FaqPageTemplate: React.FC<FaqPageTemplateProps> = ({ config }) => {
  useShowHeaderCtaOnScroll(true);
  return (
    <>
      <SEO {...config.seo} />
      <Layout
        pt={[70, 60, 120]}
        headerActions={config.layout.headerActions}
        fixedHeader
        overflow="undefined" // this will allow sticky sidebar to work
      >
        <ContentWrapper gap="10px" width="100%" px="20px">
          <FaqPageMenu content={config.MDXContent as Faq} />
          <FaqPageContent content={config.MDXContent as Faq} />
        </ContentWrapper>
      </Layout>
    </>
  );
};
